
export default function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">聯絡我們</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            歡迎與我們聯繫，我們很樂意為您介紹課程內容，並安排參觀時間。
            讓我們一起為孩子的美語學習之路做最好的規劃！
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* 聯絡資訊 */}
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-8">聯絡資訊</h3>
            
            <div className="space-y-6 mb-8">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-map-pin-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-1">地址</h4>
                  <p className="text-gray-600">北屯區北屯路388號2樓</p>
                  <p className="text-sm text-gray-500 mt-1">交通便利，歡迎預約參觀</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-phone-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-1">電話</h4>
                  <p className="text-gray-600">(04)22436255</p>
                  <p className="text-sm text-gray-500 mt-1">歡迎來電諮詢</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-mail-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-1">電子郵件</h4>
                  <p className="text-gray-600">richqazstrong@yahoo.com.tw</p>
                  <p className="text-sm text-gray-500 mt-1">24小時內回覆</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-time-line text-yellow-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-1">營業時間</h4>
                  <div className="text-gray-600 space-y-1">
                    <p>週一至週五：09:00 - 21:00</p>
                    <p>週六：09:00 - 21:00</p>
                    <p>週日：休息</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 地圖 */}
            <div className="bg-white rounded-lg p-4 shadow-lg">
              <h4 className="font-bold text-gray-800 mb-4">交通位置</h4>
              <div className="w-full h-64 bg-gray-200 rounded-lg flex items-center justify-center">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.123!2d120.6478!3d24.1647!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDA5JzUzLjAiTiAxMjDCsDM4JzUyLjAiRQ!5e0!3m2!1szh-TW!2stw!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="rounded-lg"
                ></iframe>
              </div>
            </div>
          </div>

          {/* QR Code 區域 */}
          <div className="bg-white rounded-lg p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">聯絡諮詢</h3>
            
            <div className="flex flex-col items-center justify-center space-y-6">
              <div className="bg-gray-50 p-6 rounded-lg">
                <img 
                  src="https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/a7f5034a184c0574bf4415ff688caa0e.jpeg"
                  alt="威斯理美語安親班 LINE QR Code"
                  className="w-64 h-64 object-contain"
                />
              </div>
              
              <div className="text-center">
                <h4 className="text-lg font-bold text-gray-800 mb-2">掃描 QR Code</h4>
                <p className="text-gray-600 mb-4">加入我們的 LINE 官方帳號</p>
                <div className="flex items-center justify-center space-x-2 text-green-600">
                  <i className="ri-line-fill text-2xl"></i>
                  <span className="font-medium">即時諮詢與預約</span>
                </div>
              </div>
              
              <div className="w-full bg-blue-50 rounded-lg p-4">
                <h5 className="font-bold text-blue-800 mb-2">透過 LINE 您可以：</h5>
                <ul className="text-sm text-blue-700 space-y-1">
                  <li>• 即時諮詢課程內容</li>
                  <li>• 預約參觀時間</li>
                  <li>• 了解最新活動資訊</li>
                  <li>• 快速獲得回覆</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* 常見問題 */}
        <div className="mt-20">
          <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center">常見問題</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg p-6 shadow-lg">
              <h4 className="font-bold text-gray-800 mb-3">
                <i className="ri-question-line text-blue-600 mr-2"></i>
                如何報名課程？
              </h4>
              <p className="text-gray-600 leading-relaxed">
                您可以透過電話、電子郵件或掃描 QR Code 加入 LINE 與我們聯繫。我們會安排時間讓您參觀環境，了解課程內容後再決定是否報名。
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-lg">
              <h4 className="font-bold text-gray-800 mb-3">
                <i className="ri-question-line text-blue-600 mr-2"></i>
                是否提供試聽課程？
              </h4>
              <p className="text-gray-600 leading-relaxed">
                是的，我們提供免費試聽課程。建議您先預約參觀，了解我們的教學方式後，再安排孩子參加試聽課程。
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-lg">
              <h4 className="font-bold text-gray-800 mb-3">
                <i className="ri-question-line text-blue-600 mr-2"></i>
                安親班的接送時間？
              </h4>
              <p className="text-gray-600 leading-relaxed">
                我們提供彈性的接送時間，配合家長的工作時間安排。具體時間可以根據您的需求調整。
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-lg">
              <h4 className="font-bold text-gray-800 mb-3">
                <i className="ri-question-line text-blue-600 mr-2"></i>
                師生比例如何？
              </h4>
              <p className="text-gray-600 leading-relaxed">
                我們採用小班制教學，每班學生人數不超過12人，確保每位孩子都能得到充分的關注和指導。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
